import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

export function setCardListContent(store) {
  return {};
}

export function setErrorCodeVerbiage(store) {
  return {
    errorCodeContent: store.verbiageContainer,
    errorScenarios: store.errorScenarios
  };
}

export function setOccupationContent(store) {
  return {
    occupationOptionContent: store.name_value_pair,
  };
}
export function setIncomeSurrogateContent(store) {
  return {
    surrogateOptionContent: store.name_value_pair,
  };
}
export function setAppContent(store) {
  return {
    technicalErrorContent: store.technical_error,
  };
}
export function useOccupationContent(prop) {
  const apiAppContent = useSelector(
    (state) => state.AppState.occupationDetails
  );

  const [pageData, setPageData] = useState(setOccupationContent(apiAppContent));

  useEffect(() => {
    setPageData(setOccupationContent(apiAppContent));
  }, [apiAppContent]);

  return pageData;
}

export function useCardListContent(prop) {
  const cardListContent = useSelector(
    (state) => state.AppState.cardNameContent
  );

  const [pageData, setPageData] = useState(setCardListContent(cardListContent));

  useEffect(() => {
    setPageData(setCardListContent(cardListContent));
  }, [cardListContent]);

  return pageData;
}

export function useAppContent(prop) {
  const apiAppContent = useSelector((state) => state.AppState.appContent);

  const [pageData, setPageData] = useState(setAppContent(apiAppContent));

  useEffect(() => {
    setPageData(setAppContent(apiAppContent));
  }, [apiAppContent]);

  return pageData;
}

export function useErrorCodeVerbiage(prop) {
  const apiErrorContent = useSelector((state) => state.AppState.errorContent);
  const [pageData, setPageData] = useState(
    setErrorCodeVerbiage(apiErrorContent)
  );

  useEffect(() => {
    setPageData(setErrorCodeVerbiage(apiErrorContent));
  }, [apiErrorContent]);

  return pageData;
}

// Hook
export function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef();
  // Store current value in ref
  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current;
}
